<template>
  <div class="custom-select" :tabindex="tabindex" @blur="open = false">
    <input name="comments" type="text" autocomplete="off" :disabled="disabled" id="location" @click="open = !open"
      @input="
        search();
      $emit('setName', searchQuery);
      " @keydown.down="onArrowDown" @keydown.up="onArrowUp" @keydown.enter="onEnter" @blur="validateOnBlur"
      :placeholder="placeholder" :class="[open && 'open', error && 'error-border']" v-model="searchQuery" />
    <div class="items shadow" :class="{ selectHide: !open }">
      <p v-if="isLoading" class="loading">
        {{ $t(`inputs.passengersAutoComplete.messages.${loadingMessage}`) }}
      </p>
      <div v-else v-for="(result, i) of results" :key="i" @click="
        selected = result;
      searchQuery = selected.phone_number;
      open = false;
      emitSelected();
      checkOrdersWithinThirtyMinutes();
      " :class="{ 'is-active': i === arrowCounter }">
        <span>{{ result.full_name }}</span><br />
        <span style="font-size: 14px; color: #788e98">{{
          result.phone_number || result.username
        }}</span>
      </div>
      <div v-if="searchQuery && !results.length && !isLoading" @click="
        selected = searchQuery;
      arrowCounter = -1;
      open = false;
      $emit('setName', selected);
      ">
        <span style="font-size: 14px; color: #788e98">{{ disableAutocomplete ? $t("inputs.passengersAutoComplete.addPhoneNumber") : $t("common.add") }}
        </span>
        <span>{{ searchQuery }}</span>
      </div>
    </div>
    <div>
      <span v-if="warningOrder != null" style="font-size: 14px; color: #FF0000">{{ warningOrder }} </span>
    </div>
  </div>
</template>

<script>
/*global google */
/*eslint no-undef: "error"*/
import axios from "axios";
let CancelToken = axios.CancelToken;
var cancelRequest;

export default {
  name: "PassengersAutoComplete",
  props: {
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: {
      required: true,
    },
    value: {
      required: true,
    },
    disableAutocomplete: {
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selected: "",
      open: false,
      arrowCounter: -1,
      results: [],
      isLoading: true,
      loadingMessage: "enterKeywords",
      searchQuery: "",
      warningOrder: null
    };
  },
  watch: {
    value: function (val) {
      if (!val) {
        this.searchQuery = "";
        this.warningOrder = null;
      } else if (typeof val === "object") {
        if (Object.keys(val).length === 0) this.searchQuery = "";
      } else {
        this.searchQuery = val;
      }
    },
    open: function (val) {
      if (val) document.addEventListener("click", this.handleClickOutside);
      else document.removeEventListener("click", this.handleClickOutside);
    },
  },
  methods: {
    validateOnBlur(evt) {
      if (!this.$el.contains(evt.relatedTarget)) {
        this.open = false;
        this.$emit("validate");
      }
    },
    getResults() {
      if (cancelRequest) cancelRequest();
      axios
        .get("passenger_numbers", {
          params: {
            search: this.searchQuery,
          },
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c; // c is the cancel function
          }),
        })
        .then((res) => {
          if (res.data.data.length > 0) {
            this.isLoading = false;
          }
          this.results = [];
          res.data.data.forEach((item) => {
            this.results.push(item);
          });
        });

      // let input = document.getElementById("location");
      // const monaco = new google.maps.LatLng(43.7364679, 7.4212918);

      // const center = { lat: 43.7364679, lng: 7.4212918 };

      // // Create a bounding box with sides ~10km away from the center point
      // const defaultBounds = {
      //   north: center.lat,
      //   south: center.lat,
      //   east: center.lng,
      //   west: center.lng,
      // };

      // let map = new google.maps.Map(input, {
      //   zoom: 14,
      // });

      // var request = {
      //   bounds: defaultBounds,
      //   strictBounds: false,
      //   query: this.searchQuery,
      //   fields: ["name"],
      //   types: ["establishment"],
      // };

      // const service = new google.maps.places.PlacesService(map);

      // service.textSearch(request, (res, status) => {
      //   if (status === google.maps.places.PlacesServiceStatus.OK) {
      //     this.isLoading = false;
      //     let newResults = [];
      //     for (var i = 0; i < (res.length < 10 ? res.length : 10); i++) {
      //       newResults.push(res[i]);
      //     }
      //     this.results = newResults.reverse();
      //   }
      // });
    },

    resetResults() {
      this.results = [];
      this.isLoading = true;
      this.searchQuery = "";
      this.loadingMessage = "enterKeywords"
    },
    checkOrdersWithinThirtyMinutes(phone = null) {
      var number = this.selected.phone_number;
      if (phone != null)
        number = phone;
      axios
        .get("booking/checkOrdersWithinThirtyMinutes", {
          params: {
            phone_number: number
          }
        })
        .then((res) => {
          if (res.data.data != null) {
            this.warningOrder = res.data.data;
          } else {
            this.warningOrder = null;
          }
        });
    },

    search() {
      this.open = true;
      this.loadingMessage = this.searchQuery ? "loading" : "enterKeywords";
      if (this.searchQuery) this.getResults();
      else this.isLoading = true;
    },
    emitSelected() {
      this.$emit("input", this.selected);
      //   window.requestAnimationFrame(() => {
      //     this.$emit("validate");
      //   });
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.open = false;
        this.arrowCounter = -1;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      if (this.open && this.results) {
        this.selected = this.results[this.arrowCounter];
        this.searchQuery = this.selected.phone_number;
        this.arrowCounter = -1;
        this.open = false;
        this.$emit("input", this.selected);
      }
    },
  },
};
</script>

<style scoped>
p {
  margin: 0 !important;
}

input {
  width: 100%;
  max-width: none;
  padding: 16px 15px;
  font-size: 14px;
  border-radius: 10px;
  border: 1px solid #c1c5d8;
  background-color: #f7f8fa;
  float: left;
  color: #202731;
}

input:focus {
  border-color: #202731;
  outline: none;
}

input::placeholder {
  color: #788e98;
}

.shadow {
  box-shadow: 0 0 6px rgba(0, 11, 138, 0.12) !important;
}

.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  float: left;
}

.custom-select .selected {
  background-color: #f7f8fa;
  width: 100%;
  border-radius: 10px;
  color: #788e98;
  border: 1px solid #c1c5d8;
  cursor: pointer;
  user-select: none;
  padding: 16px 15px;
  float: left;
}

.custom-select .selected span {
  width: max-content;
  float: left;
  font-size: 14px;
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 26px;
  right: 15px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #c1c5d8 transparent transparent transparent;
}

.custom-select .items {
  color: #fff;
  border-radius: 10px;
  overflow: hidden;
  position: absolute;
  background-color: #ffffff;
  left: 0;
  right: 0;
  top: calc(100% + 8px);
  padding: 10px;
  z-index: 1;
  height: auto;
  max-height: 300px;
  overflow-y: overlay;
}

.custom-select .items::-webkit-scrollbar {
  width: 0.2em;
}

.custom-select .items::-webkit-scrollbar-track {
  background-color: transparent;
}

.custom-select .items::-webkit-scrollbar-thumb {
  background-color: #c1c5d8;
  border-radius: 9999px;
}

.custom-select .items div {
  color: #fff;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
  padding: 15px 18px;
  color: #2f434c;
  font-size: 16px;
}

.custom-select .items .loading {
  color: #788e98;
  padding: 1em;
  font-size: 14px;
}

.custom-select .items div:not(:last-child) {
  border-bottom: 1px solid #e0e0df;
}

.custom-select .items div:last-child {
  border-radius: 0 0 8px 8px;
}

.custom-select .items div:first-child {
  border-radius: 8px 8px 0 0;
}

.custom-select .items div:hover,
.custom-select .items div:focus {
  background-color: #f7f8fa;
}

.selectHide {
  display: none;
}

.is-active {
  background-color: #f7f8fa;
}

.error-border {
  border: 1px solid red;
}
</style>
